<template>
  <button
    class="bg-pink-700 w-full max-w-sm hover:bg-opacity-[0.85] text-xl text-white text-center hover:no-underline rounded-full py-2 px-4 shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300 hover:duration-150 ease-in-out disabled:bg-zinc-400 disabled:pointer-events-none disabled:shadow-none"
    :disabled="disabled"
    @click="onClick"
  >
    {{ title }}
  </button>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
  },

  methods: {
    onClick() {
      this.$emit("click");
    },
  },
};
</script>
